'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slate = require('slate');
/**
 * Plugin to prevent an empty document.
 *
 * @param {String|Block} type
 */


function NoEmpty(type) {
  type = typeof type == 'string' ? _slate.Block.create({
    type: type,
    nodes: [_slate.Text.create()]
  }) : type;

  var onBeforeChange = function onBeforeChange(state) {
    var document = state.document; // If document is not empty, it continues

    if (!document.nodes.isEmpty()) {
      return;
    } // Reset the state


    return _slate.State.create({
      document: _slate.Document.create({
        nodes: [type]
      })
    });
  };

  return {
    onBeforeChange: onBeforeChange
  };
}

exports.default = NoEmpty;